import { Box, Illustration, Typography } from "@drone-js/core";
import type { FunctionComponent } from "react";

export const NotFoundPage: FunctionComponent = () => {
    return (
        <Box width="100%" height="100dvh" display="flex" justifyContent="center" alignItems="center">
            <Box display="block" gap="16" alignItems="center" qM={{ display: "flex" }} px="16">
                <Illustration id="placeholder.image.error" alt="The image is loading" width="200px" />
                <Box>
                    <Typography variant="heading-xl" mb="12">
                        Page not found
                    </Typography>
                    <Typography variant="body-default">
                        We looked everywhere, but couldn't find the page you requested.
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};
